import React, { useRef, useState, useEffect } from 'react';
import styles from '../stellavillelaadvocacia/stellavillelaadvocacia.module.scss';
import Perfil from './src/perfil.png';
import LinkPersonalizado11 from '../../components/LinkPersonalizado11/linkPersonalizado11.tsx';

const Stellavillelaadvocacia: React.FC = () => {
    const imgRef = useRef<HTMLImageElement>(null);
    const [height, setHeight] = useState(window.innerHeight);

    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div className={styles.stellavillelaadvocacia}>
            <div className={styles["body-thunder"]} style={{ minHeight: `${height}px` }}>
                <div className={styles["background-thunder"]}></div>
                <div className={`${styles["container-thunder"]}`} >
                    <div className={styles["img-wrapper"]}>
                        <img
                            ref={imgRef}
                            className={styles["img-perfil"]}
                            src={Perfil}
                            alt="Profile Picture"
                        />
                    </div>
                    <h1 className="mt-4">STELLA VILLELA</h1>
                    <p className="mb-4">Advocacia e Consultoria</p>
                    <div className={styles.links}>
                        <LinkPersonalizado11
                            href="https://www.instagram.com/stellavillelaadvocacia?igsh=MWNoYjd4NnViMmVsbg=="
                            title="Instagram"
                            backgroundColor="#ffffff"
                            backgroundColorHover="#ffffff"
                            colorText="#242d4c"
                            borderColor="#242d4c"
                        />
                        <LinkPersonalizado11
                            href="https://wa.me/5517996100465?text=Olá, gostaria de mais informações..."
                            title="Whatsapp"
                            backgroundColor="#ffffff"
                            backgroundColorHover="#ffffff"
                            colorText="#242d4c"
                            borderColor="#242d4c"
                        />
                        <LinkPersonalizado11
                            href="https://maps.app.goo.gl/FVixEYRJtMdUrEGm8"
                            title="Localização"
                            backgroundColor="#ffffff"
                            backgroundColorHover="#ffffff"
                            colorText="#242d4c"
                            borderColor="#242d4c"
                        />
                        <LinkPersonalizado11
                            href="mailto:stella@svillela.com.br"
                            title="E-mail"
                            backgroundColor="#ffffff"
                            backgroundColorHover="#ffffff"
                            colorText="#242d4c"
                            borderColor="#242d4c"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Stellavillelaadvocacia;
